import { b64decode, b64encode } from '../../common/base64.js';
import { readBlobSync } from '../readBlobSync.js';
import { string2ArrayBuffer } from '../string2ArrayBuffer.js';
export const fileTypeDef = {
    File: {
        test: (file, toStringTag) => toStringTag === 'File',
        replace: (file) => ({
            $t: 'File',
            v: b64encode(string2ArrayBuffer(readBlobSync(file))),
            type: file.type,
            name: file.name,
            lastModified: new Date(file.lastModified).toISOString(),
        }),
        revive: ({ type, v, name, lastModified, }) => {
            const ab = b64decode(v);
            const buf = ab.buffer.byteLength === ab.byteLength
                ? ab.buffer
                : ab.buffer.slice(ab.byteOffset, ab.byteOffset + ab.byteLength);
            return new File([new Uint8Array(buf)], name, {
                type,
                lastModified: new Date(lastModified).getTime(),
            });
        },
    },
};
export default fileTypeDef;
